import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Spinner from "../../../Layouts/Spinner";
import axios from "axios";
import ReactSelect from "react-select";
import { addOccassionValidation, addSizeValidation } from "../../../Constant/constant";
import { addSize } from "../../../../redux/size/action";
import UploadImage from "../../Category/UploadImage";
import { addOccassion } from "../../../../redux/occassion/action";
import FileUpload from "../../../Common/ImageUpload/imageUpload";
import { handleImageUpload } from "../../../Common/ImageUpload/handleImageUpload";

const AddOccassion = () => {
  const [loading, setLoading] = useState(false);
  const getLocalToken = localStorage.getItem("authcheck");
  const [selectStatus, setSelectStatus] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [update, setUpdate] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFile1, setSelectedFile1] = useState(null);
  const [profileLoader, setProfileLoader] = useState(false);

  const prop = { title: " Image", name: "image" };
  const prop1 = { title: " ar_Image", name: "ar_image" };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      status: 1,
      name: "",
      ar_name: "",
      position: 1,
      meta_description: "",
      meta_h1_tag: "",
      meta_h2_tag: "",
      meta_title: "",
      page_title: "",
      home_view: "",
    },
    validationSchema: addOccassionValidation,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleUploadImage = (e, name) => {
    const file = e.target.files[0];
    setProfileLoader(true);
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const imgData = {
          file: reader.result,
        };
        const token = getLocalToken;
        axios
          .post(`${process.env.REACT_APP_API_ENDPOINT}/auth/image-upload`, imgData, {
            headers: {
              "Content-Type": "application/json",
              "auth-token": token,
            },
          })
          .then((response) => {
            if (response.data.status) {
              setProfileLoader(false);
              formik.setFieldValue(name, response.data.response.url);
            }
          })
          .catch((e) => {
            console.log(e.message, "img error");
            setProfileLoader(false);
          });
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (values) => {
    const data = {
      ...values,
      image: formik.values.image,
      // ar_image: formik.values.ar_image,
      home_view: false,
    };
    dispatch(addOccassion(data, setLoading, navigate));
  };

  const handleChangeStatus = (e) => {
    const gender = e.target.value;
    setSelectStatus(gender);
    formik.setFieldValue("status", Number(gender));
  };

  const positionOptions = Array.from({ length: 50 }, (_, i) => ({
    value: i + 1,
    label: (i + 1).toString(),
  }));

  const showInHomeOptions = [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
  ];

  console.log(formik.values, "sadfsfdsfsfdsfsd");
  return (
    <div className="card-head order-card order-timing">
      <div className="sub-head">
        <h4 >Add Occasion</h4>
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="row  product-row">
          <div className="col-md-3 ">
            <div style={{ position: 'sticky', top: '0' }} className="add-category-row d-flex flex-column">

              <div className="add-category-wrapper ">
                <div className="addcategory-padding">
                  <label htmlFor="status">Status</label>
                  <select
                    id="status"
                    title="status"
                    className="form-control"
                    onChange={handleChangeStatus}
                    onBlur={formik.handleBlur}
                    value={formik.values.status}
                  >
                    <option value="">Select Status</option>
                    <option value="1">Active</option>
                    <option value="2">Inactive</option>
                  </select>
                  {formik.touched.status && formik.errors.status ? (
                    <div className="error">{formik.errors.status}</div>
                  ) : null}
                </div>
              </div>

              <div className="add-category-wrapper ">
                <div className="addcategory-padding">
                  <label>Position</label>
                  <ReactSelect
                    value={positionOptions.find(
                      (option) => option.value == formik.values?.position
                    )}
                    placeholder={"Position"}
                    id="position"
                    name="position"
                    options={positionOptions}
                    onChange={(option) => {
                      formik.setFieldValue("position", option?.value);
                    }}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.position && formik.errors.position && (
                    <div className="error">{formik.errors.position}</div>
                  )}
                </div>
              </div>
            </div>
            {/* <div>
              <label>Show in Home</label>
              <ReactSelect
                value={showInHomeOptions.find(
                  (option) => option.value == formik.values?.home_view
                )}
                placeholder={"Show in Home"}
                id="home_view"
                name="home_view"
                options={showInHomeOptions}
                onChange={(option) => {
                  formik.setFieldValue("home_view", option?.value);
                }}
                onBlur={formik.handleBlur}
              />
              {formik.touched.home_view && formik.errors.home_view && (
                <div className="error">{formik.errors.home_view}</div>
              )}
            </div> */}
          </div>
          <div className="col-md-9 ">
            <div className=" add-category-wrapper" >
              <div className="add-cat-head">
                <h4>Basic Info</h4>
              </div>
              <div className="addcategory-padding">
                <div className="row  ">
                  <div className="col-md-6 form-group ">
                    <label>Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter name"
                      name="name"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.name}
                    />
                    {formik.touched.name && formik.errors.name ? (
                      <div className="error">{formik.errors.name}</div>
                    ) : null}
                  </div>
                  <div className="col-md-6 form-group">
                    <label>Ar Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter ar name"
                      name="ar_name"
                      style={{ direction: "rtl" }}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.ar_name}
                    />
                    {formik.touched.ar_name && formik.errors.ar_name ? (
                      <div className="error">{formik.errors.ar_name}</div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>


            <div className=" add-category-wrapper w-100 my-3" >
              <div className="add-cat-head">
                <h4>Image Upload</h4>
              </div>
              <div className="addcategory-padding">
              <FileUpload
                        files={selectedFile}
                        setFiles={setSelectedFile}
                        formik={formik}
                        // maxWidth={368}
                        prop={{
                          title: "",
                          name: "image",
                        }}
                        // maxHeight={156}
                        onFileSelect={async (e) => {
                          try {
                            const file = e.target.files[0];
                            if (!file) return;

                            await handleImageUpload(
                              file,
                              { title: "images", name: "image" },
                              "image",
                              formik,
                              // 368,
                              // 156
                            );
                            setSelectedFile(file);
                          } catch (error) {
                            console.error(error);
                          }

                        }}
                      />
              </div>
              <div className="error">{formik.errors.image} </div>
            </div>
            <div className=" add-category-wrapper" >
              <div className="add-cat-head">
                <h4>SEO</h4>
              </div>
              <div className="addcategory-padding">
                <div className=" row ">
                  <div className="col-md-6 form-group">
                    <label>page title</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter page title"
                      name="page_title"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.page_title}
                    />
                    {formik.touched.page_title && formik.errors.page_title ? (
                      <div className="error">{formik.errors.page_title}</div>
                    ) : null}
                  </div>
                  <div className="col-md-6 form-group">
                    <label>Meta title</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter meta title"
                      name="meta_title"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.meta_title}
                    />
                    {formik.touched.meta_title && formik.errors.meta_title ? (
                      <div className="error">{formik.errors.meta_title}</div>
                    ) : null}
                  </div>
                  <div className="col-md-6 form-group">
                    <label>Meta H1 tag</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Meta H1 tag"
                      name="meta_h1_tag"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.meta_h1_tag}
                    />
                    {formik.touched.meta_h1_tag && formik.errors.meta_h1_tag ? (
                      <div className="error">{formik.errors.meta_h1_tag}</div>
                    ) : null}
                  </div>
                  <div className="col-md-6 form-group">
                    <label>Meta H2 tag</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Meta H2 tag"
                      name="meta_h2_tag"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.meta_h2_tag}
                    />
                    {formik.touched.meta_h2_tag && formik.errors.meta_h2_tag ? (
                      <div className="error">{formik.errors.meta_h2_tag}</div>
                    ) : null}
                  </div>
                  <div className="col-12 form-group">
                    <label>Meta Description</label>
                    <textarea
                      className="form-control"
                      class="form-control"
                      aria-label="With textarea"
                      value={formik.values?.meta_description}
                      placeholder="Meta Description"
                      id="meta_description"
                      name="meta_description"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      touched={formik.touched}
                      errors={formik.errors}
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="d-flex align-items-center justify-content-between back-update  "
              style={{ columnGap: "20px" }}
            >
              <button
                className="back-btn"
                onClick={() => {
                  navigate("/brand");
                }}
                style={{ width: "max-content" }}
              >
                Back
              </button>
              <button
                className="submit-btn   "
                style={{ width: "max-content" }}
                type="submit"
              >
                {!loading ? "Submit" : <Spinner />}
              </button>
            </div>
          </div>
        </div >


      </form >
    </div >
  );
};

export default AddOccassion;
